(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('BridgeService', BridgeService);

    BridgeService.$inject = ['$http', '$q', 'RequestService', 'ModalConstructor', 'AlertModalService'];

    function BridgeService($http, $q, RequestService, ModalConstructor, AlertModalService) {

        return {
            // API Methods
            listBridge: listBridge,
            getBridge: getBridge,
            getTypes: getTypes,
            getPorts: getPorts,
            getMulticastLists: getMulticastLists,
            getRgModesOLT8820G: getRgModesOLT8820G,
            getRgModesIntelbras: getRgModesIntelbras,
            getIpProfiles: getIpProfiles,
            getIpModes: getIpModes,
            getSipProfiles: getSipProfiles,
            getValidationRules: getValidationRules,
            getFxsValidationRules: getFxsValidationRules,
            addBridge: addBridge,
            updateBridge: updateBridge,
            deleteBridge: deleteBridge,
            getCpeVoipProfiles: getCpeVoipProfiles,
            // Modal Methods
            addBridgeSimpleModalConstructor: addBridgeSimpleModalConstructor,
            addBridgeModalConstructor: addBridgeModalConstructor,
            editBridgeModalConstructor: editBridgeModalConstructor,
            successModalConstructor: successModalConstructor,
            warningModalConstructor: warningModalConstructor,
            errorModalConstructor: errorModalConstructor,
            confirmationModalConstructor: confirmationModalConstructor,
            listBridgePages: listBridgePages,

            addBridgeOnuModalConstructor: addBridgeOnuModalConstructor
        };

        function listBridge(filters) {
            var expressionFilter = constructFilter(filters || {});
            return $http.get(apiUrl(), {params: expressionFilter, ignoreLoadingBar: true}).then(responseData);
        }

        function listBridgePages(filters) {
            //var expressionFilter = constructFilter(filters || {});      
            return $http.get(apiUrl('pages'), {params: filters, ignoreLoadingBar: true});//.then(responseData);
        }

        function getBridge(bridgeId) {
            return $http.get(apiUrl(bridgeId)).then(responseData);
        }

        function getPorts(oltModel) {
            var ports = {
                OLT: [],
                ONU: []
            };

            if (oltModel !== undefined) {
                if (oltModel === 'Intelbras8820i') {
                    for (var i = 1; i <= 8; i++) {
                        ports.OLT.push({label: 'Eth ' + i, value: i, type: 'GE1'});
                    }
                } else {
                    for (var i = 2; i <= 9; i++) {
                        ports.OLT.push({label: 'Eth ' + i, value: i, type: 'GE1'});
                    }
                }
            } else {
                for (var i = 1; i <= 9; i++) {
                    ports.OLT.push({label: 'Eth ' + i, value: i, type: 'GE1'});
                }
            }

            for (var i = 1; i <= 10; i++) {
                if (i <= 8) {
                    ports.ONU.push({label: 'Gpon ' + i, value: i, type: 'GPON'});
                } else {
                    ports.OLT.push({label: '10GE ' + (i - 8), value: i - 8, type: 'GE10'});
                }
            }

            return $q.resolve(ports);
        }

        function getTypes(model, rgMode) {
            var types = {
                OLT: [
                    {label: 'Uplink', value: 'UPLINK'},
                    {label: 'Downlink', value: 'DOWNLINK'},
                    {label: 'Intralink', value: 'INTRALINK'},
                    {label: 'TLS', value: 'TLS'}
                ],
                ONU: [
                    {label: 'Downlink', value: 'DOWNLINK'},
                    {label: 'TLS', value: 'TLS'}
                ]
            };

            if (model !== null && model !== 'Intelbras8820i') {
                types.OLT.push({label: 'Rlink', value: 'RLINK'});
            }

            return $q.resolve(types);
        }

        function getMulticastLists(data, hideLoader) {
            return $http
                    .get(mcListUrl(), {params: data, ignoreLoadingBar: !!hideLoader})
                    .then(function (response) {
                        if (response.data.length) {
                            response.data.unshift({id: null, listId: ''});
                        }
                        return response.data;
                    });
        }

        function getRgModesOLT8820G(meProfile) {
            if (meProfile === 'intelbras-110gi') {
                return $q.resolve([
                    {label: 'OMCI', value: ''},
                    //{label: 'Roteamento (RG)', value: 'RG_ROTEAMENTO'},
                    {label: 'PPPoE', value: 'RG_BPPPOE'}
                ]);
            } else if (meProfile === 'intelbras-110' || meProfile === 'intelbras-110g' || meProfile === 'intelbras-110b') {
                return $q.resolve([
                    {label: 'OMCI', value: ''}
                    //{label: 'Bridged', value: 'RG_BRIDGED'}
                    //{label: 'PPPoE', value: 'RG_BPPPOE'}
                ]);
            } else if (meProfile === 'intelbras-1420g' || meProfile === 'intelbras-142ng')  {
                return $q.resolve([
                    {label: 'Roteamento (RG)', value: 'RG_ROTEAMENTO'},
                    {label: 'Bridged', value: 'RG_BRIDGED'},
                    {label: 'Routed', value: 'RG_BROUTED'},
                    {label: 'PPPoE', value: 'RG_BPPPOE'}
                ]);
            } else {
                return $q.resolve([
                    {label: 'OMCI', value: ''},
                    {label: 'Roteamento (RG)', value: 'RG_ROTEAMENTO'}
                ]);
            }
        }

        function getRgModesIntelbras(meProfile) {
            if (meProfile === 'intelbras-110g' || meProfile === 'intelbras-110b') {
                return $q.resolve([
                    {label: 'OMCI', value: ''}
                ]);
            } else if (meProfile === 'intelbras-110gi' || meProfile === 'intelbras-110') {
                return $q.resolve([
                    {label: 'OMCI', value: ''},
                    {label: 'Roteamento (RG)', value: 'RG_ROTEAMENTO'},
                    {label: 'PPPoE', value: 'RG_BPPPOE'}
                ]);
            } else {
                return $q.resolve([
                    {label: 'OMCI', value: ''},
                    {label: 'Roteamento (RG)', value: 'RG_ROTEAMENTO'}
                ]);
            }
        }

        function getIpProfiles(oltId) {
            return $http.get(profileUrl(oltId + '/sip'), {ignoreLoadingBar: true}).then(responseData);
            //return $http.get(profileUrl(oltId + '/ipcom'), { ignoreLoadingBar: true }).then(responseData);
        }

        function getCpeVoipProfiles(oltId, oltModel) {
            return $q.resolve([{index: 1, profileName: "DHCP", gateway: "0.0.0.0"}, {index: 2, profileName: "STATIC", gateway: "0.0.0.0"}]);
        }

        function getCpeVoipProfiles(oltId, oltModel, enderecoIp) {
            return $q.resolve([{index: 1, profileName: "DHCP", gateway: "0.0.0.0"}, {index: 2, profileName: "STATIC", gateway: enderecoIp}]);
        }

        function getIpModes() {
            return $q.resolve([
                {label: 'static', value: 'STATIC'},
                {label: 'dhcp', value: 'DHCP'}
            ]);
        }

        function getSipProfiles(oltId) {
            return $http.get(profileUrl(oltId + '/sip'), {ignoreLoadingBar: true}).then(responseData);
        }

        function getValidationRules() {
            return {
                Zhone8820G: {
                    name: {},
                    vlan: {min: 0, max: 4094},
                    slan: {min: 0, max: 4094},
                    maxMulticastStreams: {min: 1, max: 210}
                },
                Intelbras8820i: {
                    name: {},
                    vlan: {min: 2, max: 4090},
                    slan: {min: 2, max: 4090},
                    maxMulticastStreams: {min: 0, max: 255}
                }
            };
        }

        function getFxsValidationRules() {
            return {
                OLT8820G: {
                    credentials: {pattern: '^[\\S\\s]{1,50}$'}
                },
                Intelbras8820i: {
                    credentials: {pattern: '^\\S{1,50}$'}
                }
            };
        }

        function addBridge(data) {
            return $http.post(apiUrl(), data);
        }

        function updateBridge(data) {
            return $http.put(apiUrl(), data);
        }

        function deleteBridge(bridgeId) {
            return $http.delete(apiUrl(bridgeId)).then(responseData);
        }

        // Modal Methods
        function addBridgeSimpleModalConstructor(onuItem) {
            var addBridge = {
                templateUrl: 'app/components/bridge/bridge-simple-add.html',
                controller: 'BridgeSimpleAddController',
                controllerAs: 'vmBridgeAdd',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    onuItem: function () {
                        return onuItem
                    },
                }
            };
            return ModalConstructor.open(addBridge);
        }

        function addBridgeOnuModalConstructor(scope, onuItem) {
            var modal = bridgeModalConfig();
            modal.scope = scope;
            modal.resolve.bridgeData = {
                interface: {value: 'ONU', disabled: true},
                olt: {model: {id: onuItem.oltId, name: onuItem.oltName, model: onuItem.oltModel}},
                port: {model: {label: onuItem.portInterface, value: onuItem.gponPort, type: 'GPON'}},
                onu: {model: {id: onuItem.id, name: onuItem.name, meProfile: onuItem.meProfile}}
            };
            return ModalConstructor.open(modal);
        }

        function addBridgeModalConstructor(scope, bridgeData) {
            var modal = bridgeModalConfig();
            modal.scope = scope;           
            modal.resolve.bridgeData = bridgeData;
            return ModalConstructor.open(modal);
        }

        function editBridgeModalConstructor(scope, bridgeId) {
            var modal = bridgeModalConfig();
            modal.scope = scope;
            modal.resolve.bridgeId = bridgeId;
            ModalConstructor.open(modal);
        }

        function successModalConstructor(action, isMultiple) {
            return AlertModalService.success(action, isMultiple, 'bridges');
        }

        function warningModalConstructor(list, response, action, dontCloseAll) {
            return AlertModalService.warning(list, response, action, 'bridges', dontCloseAll);
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'bridges');
        }

        function confirmationModalConstructor(bridgeData, dataAction) {
            var confirm = {
                templateUrl: 'app/components/bridge/bridge-confirm.html',
                controller: 'BridgeConfirmController',
                controllerAs: 'vmBridgeConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    bridgeData: function () {
                        return bridgeData;
                    }
                },
                avoidCancel: true
            };
            ModalConstructor.open(confirm);
        }

        function bridgeModalConfig() {
            return {
                windowTemplateUrl: 'app/components/bridge/bridge-modal.html',
                templateUrl: 'app/components/bridge/bridge-add.html',
                controller: 'BridgeAddController',
                controllerAs: 'vmBridgeAdd',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'modal-bridge',
                resolve: {
                    bridgeId: null,
                    bridgeData: null,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('bridge');
                            return $translate.refresh();
                        }]
                }
            };
        }

        // Helper Function
        function apiUrl(method) {
            return RequestService.apiUrl('bridges', method);
        }

        function profileUrl(method) {
            return RequestService.apiUrl('profiles', method);
        }

        function mcListUrl(method) {
            return RequestService.apiUrl('mcls', method);
        }

        function constructFilter(filters) {
            angular.forEach(filters, function (value, key, obj) {
                if (!value) {
                    delete obj[key];
                }
            });
            return filters;
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

    }
})();
